export enum MacronutrientDistributionTypeEnum {
  OMS = 'OMS',
  MX = 'NORMA_OFICIAL_MEXICANA_NOM_043_SSA2_2012', // Oficial Mexicana NOM-043-SSA2-2012
  SMAE = 'SISTEMA_MEXICANO_DE_ALIMENTOS_EQUIVALENTES', // Sistema Mexicano de Alimentos Equivalentes
  // DGA_USDA_HHS = 'USDA-HHS Development of the Dietary Guidelines', // Translate
  DGA_USDA_HHS = 'USDA_HHS_GUIAS_ALIMENTARIAS_PARA_LOS_ESTADOS_UNIDOS', // USDA-HHS Guías Alimentarias para los Estadounidenses
}


